import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { Cell, Legend, Pie, PieChart, Tooltip } from 'recharts';
import TaskApiService from '../../api/TaskApiService';

const taskApiService = new TaskApiService();

const parseSettings = (settings) => {
    try {
        if (!settings || settings === '{}') {
            return {};
        }

        return typeof settings === 'string' ? JSON.parse(settings) : settings;
    }
    catch (error) {
        console.error('Error parsing jsonSettings:', error);
        return {};
    }
};

const formatDate = (value) => {
    if (!value) {
        return '';
    }

    const date = new Date(`${value}T00:00:00`);

    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    }).format(date);
};

const DashboardTaskSummary = ({ jsonSettings }) => {
    const [statuses, setStatuses] = useState([]);
    const [tasks, setTasks] = useState([]);
    const COLORS = ['#d88487', '#83a6ed', '#8dd1e1', '#82ca9d', '#a4de6c', '#d0ed57', '#ffc658', '#ffa726'];
    const settings = parseSettings(jsonSettings);
    const isDateRangeFilterActive = settings.dateRangeEnabled && (settings.dateRange?.start || settings.dateRange?.end);
    const formattedStartDate = formatDate(settings.dateRange?.start);
    const formattedEndDate = formatDate(settings.dateRange?.end);
    const dateRangeLabel = formattedStartDate && formattedEndDate
        ? `${formattedStartDate} - ${formattedEndDate}`
        : formattedStartDate
            ? `From ${formattedStartDate}`
            : formattedEndDate
                ? `Through ${formattedEndDate}`
                : '';

    useEffect(() => {
        const dateRange = settings.dateRangeEnabled && (settings.dateRange?.start || settings.dateRange?.end)
            ? settings.dateRange
            : null;

        taskApiService.getTaskStatuses().then((taskStatuses) => {
            setStatuses(taskStatuses);
        });

        taskApiService.getTaskByStatus(dateRange).then((taskByStatus) => {
            setTasks(taskByStatus);
        });
    }, [jsonSettings]);

    const getStatusNameById = (id) => {
        const status = statuses.find((status) => status.stId === id);
        return status ? status.stName : id;
    };

    return (
        <Grid container direction='column' justifyContent='center' alignItems='center' style={{ height: '100%', overflow: 'auto' }}>
            <Grid item>
                <Typography variant='h6'>Task Summary</Typography>
                {isDateRangeFilterActive && dateRangeLabel && (
                    <Typography variant='body2' color='text.secondary' align='center'>
                        {dateRangeLabel}
                    </Typography>
                )}
            </Grid>
            <Grid item>
                {tasks.length === 0 ? (
                    <Typography variant='body1' color='textSecondary'>
                        {isDateRangeFilterActive ? 'No tasks found for the selected date range' : 'No tasks found'}
                    </Typography>
                ) : (
                    <PieChart width={600} height={400}>
                        <Pie
                            dataKey='tasks'
                            data={tasks}
                            cx='50%'
                            cy='50%'
                            outerRadius={80}
                            fill='#8884d8'
                        >
                            {tasks.map((entry, index) => (<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}/>))}
                        </Pie>
                        <Tooltip />
                        <Legend formatter={(value, entry) => `${getStatusNameById(entry.payload.statusId)}`}/>
                    </PieChart>
                )}
            </Grid>
        </Grid>
    );
};
export default DashboardTaskSummary;
